export function formatTime(secondsRaw: number): {
  hours: number;
  minutes: number;
  seconds: number;
} {
  const seconds = Math.ceil(secondsRaw);
  const noSeconds = seconds > 60 * 10 || seconds % 60 === 0; // Don't display seconds if over 10 minutes
  const noHours = seconds < 3600; // Don't display hours if under 1 hour
  const noMinutes = seconds > 12 * 3600 || (seconds < 60 && seconds > 0); // Don't display minutes if over 12 hours or if seconds are less than 60 (less than 1 minute) except if seconds are 0
  const minutes = Math.floor(seconds / 60);
  const d_seconds = seconds % 60;
  const d_hours = Math.floor(minutes / 60);
  const d_minutes = minutes % 60;
  const s_hours = noHours ? 0 : d_hours;
  const s_minutes = noMinutes ? 0 : d_minutes;
  const s_seconds = noSeconds ? 0 : d_seconds;
  return { hours: s_hours, minutes: s_minutes, seconds: s_seconds };
}
